import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Auxiliary from '../../util/Auxiliary';
import List from './List';

const Project = (props) => {
  const { authUser } = useSelector(({ auth }) => auth);

  return (
    <Auxiliary>
      <h1 className="title gx-mb-4">Daftar Proyek Integrasi dengan PP Online</h1>
      {authUser.is_superadmin ? <Link to="/project/create" className="ant-btn ant-btn-primary">Tambah Project Baru</Link> : null}
      <List />
    </Auxiliary>
  );
}

export default Project;